import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import useI18n from 'hooks/I18n/useI18n.js';

import Text from 'components/ProductIdentity/Text.jsx';

export const CLAIMS = {
    GOOD_DEAL: 'goodDeal',
    POPULAR_PRODUCTS: 'popularProducts',
    NEW_PRODUCTS: 'newProducts',
};

const CLAIMS_TRANSLATE_KEYS_PREFIX = 'salePage.selection.claims';

const Claims = props => {
    const { className, claim } = props;
    const { trans } = useI18n();

    // We change the claims number every month and have 6 different claims for each claim type
    const currentClaimsNumber = (new Date().getMonth() % 6) + 1;

    return (
        <div className={classnames(className, `claims claims-background--${claim}`)}>
            <Text family="inter" weight={500} size="14px" lineHeight="20px" color="grey8">
                {trans(CLAIMS_TRANSLATE_KEYS_PREFIX + '.' + claim + '.' + currentClaimsNumber)}
            </Text>
        </div>
    );
};

Claims.propTypes = {
    className: PropTypes.string,
    claim: PropTypes.string.isRequired,
};
export default Claims;
